const typeValues = {
    Pre: "Pre",
    Post: "Post",
    Auto: "Auto",
    Home: "Home"
};

export { typeValues }
